import React from 'react';
import { Link } from 'react-router-dom';
import Navigation from '../components/Navigation';
import Footer from '../components/Footer';
import { BookOpen } from 'lucide-react';

const Blog = () => {
  return (
    <div className="blog-page min-h-screen flex flex-col bg-bone">
      <Navigation />

      <main className="flex-1 pt-28 pb-16 px-4 sm:px-6">
        <div className="max-w-3xl mx-auto text-center">
          <div className="inline-flex items-center justify-center p-4 rounded-full bg-goldSoft/25 ring-2 ring-goldSoft/40 mb-6">
            <BookOpen className="w-10 h-10 text-indigoDeep" strokeWidth={2} aria-hidden />
          </div>

          <h1 className="text-indigoDeep text-4xl sm:text-5xl font-black tracking-tight mb-4">
            Blog
          </h1>

          <p className="text-grayWarm text-lg sm:text-xl font-semibold max-w-xl mx-auto mb-10 leading-relaxed">
            We&apos;re working hard to build this space for articles, insights, and updates on Vedic astrology.
            Please check back soon.
          </p>

          <Link
            to="/"
            className="inline-flex items-center justify-center px-8 py-3 rounded-full bg-goldSoft text-indigoDeep font-bold hover:bg-goldHover transition-colors shadow-gold"
          >
            Back to Home
          </Link>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default Blog;
